import { render, staticRenderFns } from "./AcvChartAdmin.vue?vue&type=template&id=98b31092"
import script from "./AcvChartAdmin.vue?vue&type=script&lang=js"
export * from "./AcvChartAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports